import AdSettings from "@app/utils/AdSettings";
import { configSite, configTechshow } from "@pub/config";
import {
  PageShare,
  ResponsiveImage,
  Typography,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { useLocation } from "react-router";

import styles from "./TechshowPortal.module.css";
import TechshowPortalBrochures from "./TechshowPortalBrochures";
import { TechshowPortalListingLayoutProps } from "./types";
import { BASE_TECHSHOW_PATH } from "./utils";

export default function TechshowPortalListingLayout({
  headline,
  coverImage,
  techshowBrochureSections,
  brochureImages,
  filterBrands,
  filterCategories,
  filterMap,
  selectedBrand = "",
  selectedCategory = "",
}: TechshowPortalListingLayoutProps) {
  const { Body, Heading } = Typography;
  const originalCrop = coverImage?.crops.original;
  const location = useLocation();

  return (
    <>
      <AdSettings
        //StoryData={storyData}
        pageTitle={headline || ""}
        pageType="techshowportal"
        sectionName={headline || ""}
        currentLocation={location}
        adUnits="lb1,lb2,imu1"
      />
      {originalCrop && (
        <div
          className={cx(
            styles.headingBackgroundContainer,
            styles.subpageHeadingBackgroundContainer,
          )}
        >
          <ResponsiveImage {...originalCrop} displayWidth={2000} />
        </div>
      )}

      <div
        className={cx(
          styles.bodyContainer,
          styles.gutter,
          styles.techshowBrochuresMasthead,
        )}
      >
        <div className={styles.techshowBrochuresHeader}>
          <div className={styles.techshowBreadcrumbs}>
            <a className={styles.cta} href={BASE_TECHSHOW_PATH}>
              Tech Show Portal
            </a>
            <span className={styles.separator}> | </span>
            <span>Brochures</span>
          </div>
          <Heading.SectionTitle>
            {configTechshow.brochureListing.title}
          </Heading.SectionTitle>
          <Body>{configTechshow.brochureListing.description}</Body>
        </div>
        <PageShare
          label="Share&nbsp;this"
          url={`${configSite.address}${location.pathname}`}
          title={headline}
          size={configSite.pageShare?.size}
          media={configSite.pageShare?.media}
          fill={configSite.pageShare?.fill}
        />
      </div>

      <div
        className={cx(
          styles.techshowContainer,
          styles.bodyContainer,
          styles.gutterBottom,
        )}
      >
        {techshowBrochureSections &&
          techshowBrochureSections.map((techshowBrochures, key) => (
            <TechshowPortalBrochures
              key={key}
              brochureImages={brochureImages}
              brochureSection={techshowBrochures}
              filterBrands={filterBrands}
              filterCategories={filterCategories}
              selectedBrand={selectedBrand}
              selectedCategory={selectedCategory}
              hideHeading={techshowBrochureSections.length === 1}
              filterMap={filterMap}
            />
          ))}
      </div>
    </>
  );
}
